<template>
  <v-card class="elevation-12">
    <template v-if="registry">
      <v-toolbar color="primary" dark>
        {{ registry.note }}
      </v-toolbar>

      <v-card-title class="text-center">
        <v-spacer/>
        Реестр № {{ registry.id }} от {{ registry.createdOn.format('DD.MM.YYYY') }} по {{ regionName }}
        ({{ registry.mailsCount }} шт.)
        <v-spacer/>
        <v-btn v-if="showApproveAllButton" @click="approveAllMailsDialog = true" color="primary">Подтвердить все письма
          ({{ notApprovedMailsCount }} шт)
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
            :items="mails"
            :headers="headers"
            :hide-default-footer="true"
            :disable-pagination="true"
            dense>
          <template v-slot:item="{item}">
            <tr :class="{
              'green lighten-4': item.mail && item.mail.isPerformedDelivered,
              'red lighten-4': item.mail && item.mail.isPerformedNotDelivered
            }">
              <td class="text-center">{{ item.displayNumber }}</td>
              <td class="text-center">{{ item.content.account_number }}</td>
              <td>{{ item.tempMail.address }}</td>
              <td class="text-center">{{ item.content.check_end_date }}</td>
              <td>{{ item.tempMail.receiver }}</td>

              <template v-if="item.mail">
                <td class="text-center">
                  <template v-if="item.mail.isPerformed">
                    {{ item.mail.perform.performType.name }}
                  </template>
                </td>
                <td class="text-center">
                  <template v-if="item.mail.isPerformed">
                    {{ item.mail.perform.performedOn.format('DD.MM.YYYY') }}
                  </template>
                </td>
              </template>
              <template v-else>
                <td class="text-center">
                  Не одобрено ещё
                </td>
                <td></td>
              </template>
              <td class="text-left">
                <v-btn :to="{name: 'web-client-temp-mail', params: {uid: item.tempMail.uid}}" text color="primary">
                  {{ item.tempMail.uid }}
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>

      <v-dialog v-model="approveAllMailsDialog" max-width="480px" persistent>
        <v-card :loading="loading">
          <v-card-title class="headline">
            Вы действительн хотите подтвердить все письма?
          </v-card-title>

          <v-card-text>
            Письма пойдут на дальнейщую обработку, отменить возможности небудет
          </v-card-text>

          <v-card-actions>
            <v-btn color="default" text @click="approveAllMailsDialog = false" :disabled="loading">
              Закрыть
            </v-btn>
            <v-spacer/>
            <v-btn color="success" text dark @click="onApproveButtonClicked" :disabled="loading">Да, Подтвердить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-card>
</template>

<script>
import RegistryService from "@/services/registry.service";
import Mappers from "@/mappers";
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP, LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import _ from 'underscore'

export default {
  name: "RegistryView",
  data() {
    return {
      registry: null,
      mails: [],
      loading: false,
      approveAllMailsDialog: false,

      headers: [
        {
          text: '№',
          align: 'center',
          value: 'displayNumber',
          sortable: false
        },
        {
          text: 'Лицевой счёт',
          align: 'center',
          value: 'accountNumber',
          sortable: false
        },
        {
          text: 'Адрес',
          align: 'left',
          value: 'address',
          sortable: false
        },
        {
          text: 'Дата конца госповерки ИПУ ГВ',
          align: 'center',
          value: 'checkEndDate',
          sortable: false
        },
        {
          text: 'ФИО получателя',
          align: 'left',
          value: 'receiver',
          sortable: false
        },
        {
          text: 'Статус',
          align: 'center',
          value: 'status',
          sortable: false
        },
        {
          text: 'Дата статуса',
          align: 'center',
          value: 'statusDate',
          sortable: false
        },
        {
          text: 'Идентификатор',
          align: 'center',
          value: 'uid',
          sortable: false
        }
      ]
    }
  },
  computed: {
    regionName() {
      if (this.mails.length) {
        return this.mails[0].tempMail.region.name
      }
      return ''
    },
    showApproveAllButton() {
      return this.notApprovedMailsCount > 0
    },
    notApprovedMailsCount() {
      return _.filter(this.mails, m => {
        return !m.tempMail.isApproved
      }).length
    }
  },
  methods: {
    onApproveButtonClicked() {
      this.$store.dispatch(LAYOUT_LOADING_START)
      this.loading = true

      RegistryService.approveRegistry(this.registry.id)
          .then(() => {
            this.loadRegistry()
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },

    loadRegistry() {
      this.approveAllMailsDialog = false
      this.$store.dispatch(LAYOUT_LOADING_START)
      this.loading = true

      this.registry = null
      RegistryService.getRegistry(this.$route.params.id)
          .then(response => {
            this.registry = Mappers.mapRegistry(response.data)

            this.loadMails()
          }, () => {
            this.$router.go(-1)
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    loadMails() {
      if (this.registry) {
        this.$store.dispatch(LAYOUT_LOADING_START)
        this.loading = true
        this.mails = []

        RegistryService.getRegistryMails(this.registry.id)
            .then(response => {

              this.mails = _.map(response.data, (mr, index) => {
                let registryMail = Mappers.mapRegistryMail(mr)
                registryMail.displayNumber = index + 1

                return registryMail
              })

            })
            .finally(() => {
              this.loading = false;
              this.$store.dispatch(LAYOUT_LOADING_STOP)
            })
      }
    },
  },
  created() {
    this.$store.dispatch(LAYOUT_TITLE_CHANGED, 'Просмотр реестра')

    this.loadRegistry()
  },
  watch: {
    "$route": function () {
      this.loadRegistry()
    }
  }
}
</script>

<style scoped>

</style>